import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./moreResourcesSectionV2.html";
import { MORE_RESOURCES_EVENT_CONTEXT } from '~/modules/analytics/analyticsHelper';
import { createUserActivity } from '~/modules/services/simplifiedTrialsService';
import { selectMoreResourcesSectionV2, WireI18n } from '~/modules/stores/i18nStore';

/**
 * Header glyph + accent theme per resource type (Figma node 7609:51256).
 * The section `type` is the publisher-authored content type; unknown types
 * fall back to the generic knowledge_base/blue treatment so a new type never
 * renders without a header icon.
 */

const DEFAULT_SECTION_STYLE = {
  icon: 'knowledge_base',
  theme: 'blue'
};
const SECTION_STYLES = {
  'Customization Guide': {
    icon: 'knowledge_base',
    theme: 'blue'
  },
  'Data Sheet': {
    icon: 'maintenance_plan',
    theme: 'yellow'
  },
  Webinar: {
    icon: 'play',
    theme: 'purple'
  },
  'Customer Testimonial': {
    icon: 'quotation_marks',
    theme: 'pink'
  },
  'Customer Stories': {
    icon: 'quotation_marks',
    theme: 'pink'
  },
  'Case Study': {
    icon: 'case',
    theme: 'teal'
  },
  Whitepaper: {
    icon: 'notebook',
    theme: 'indigo'
  },
  Promotion: {
    icon: 'knowledge_base',
    theme: 'blue'
  }
};
class MoreResourcesSectionV2 extends LightningElement {
  constructor(...args) {
    super(...args);
    this.resourceSection = void 0;
    this.labels = void 0;
  }
  get sectionTitle() {
    // @ts-expect-error * Automated Type Error Fix
    return this.labels[this.resourceSection.type];
  }
  get headerIcon() {
    return (SECTION_STYLES[this.resourceSection.type] ?? DEFAULT_SECTION_STYLE).icon;
  }
  get headerIconTheme() {
    return (SECTION_STYLES[this.resourceSection.type] ?? DEFAULT_SECTION_STYLE).theme;
  }
  handleAnalytics(event) {
    event.detail.customTitle = this.resourceSection.type;
    event.detail.context = MORE_RESOURCES_EVENT_CONTEXT;
    createUserActivity(this.resourceSection.type);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(MoreResourcesSectionV2, {
  publicProps: {
    resourceSection: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectMoreResourcesSectionV2
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(MoreResourcesSectionV2, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;